"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestIdleCallbackOrTimeout = void 0;
exports.requestIdleCallbackOrTimeout = (fn, timeout) => {
    if (typeof requestIdleCallback !== 'undefined') {
        const config = timeout ? { timeout } : undefined;
        requestIdleCallback(fn, config);
    }
    else {
        setTimeout(fn, timeout || 1000);
    }
};
//# sourceMappingURL=requestIdleCallbackOrTimeout.js.map